import { render, staticRenderFns } from "./CreateBlendSettings.vue?vue&type=template&id=55dd5226&scoped=true"
import script from "./CreateBlendSettings.vue?vue&type=script&lang=js"
export * from "./CreateBlendSettings.vue?vue&type=script&lang=js"
import style0 from "./CreateBlendSettings.vue?vue&type=style&index=0&id=55dd5226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dd5226",
  null
  
)

export default component.exports